/*
 * @Author: wangshengqiang
 * @Date: 2021-05-18 11:28:40
 * @LastEditTime: 2021-06-17 16:30:12
 * @LastEditors: wangshengqiang
 * @Description: 弹窗组件
 */
// 单例Alert
import React from 'react';
import { Modal } from 'zarm'; // 判断body里面是否有modal

const show = () => {
  if (document.getElementsByClassName('za-alert-container').length === 0) {
    return true;
  }

  return false;
};

const SingleAlert = option => {
  if (option !== null && option !== void 0 && option.content) {
    option.content = /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: option.content
      }
    });
  }

  if (show()) {
    return Modal.alert(option);
  }
};

export default SingleAlert;